  import Vue from 'vue'
  import App from './App.vue'
  import vuetify from './plugins/vuetify'
  import router from './router'
  import store from './store'

  // Global (non-scoped) style tweaks.
  import '@/styles/global.scss'
  
  Vue.config.productionTip = false
  
  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

  